import { get } from "lodash";
import { createSelector } from "reselect";

const newNotifications = state => get(state, "newNotifications", []);
export const newNotificationsSelector = createSelector(newNotifications, data => data);
